import { screeningAction } from '../../actions/constant';

const { GET_SCREENING_SUCCESS, GET_SCREENING_FAILURE, GET_SCREENING_LOADER, PREVIEW_SCREENING } =
  screeningAction;

const intitialstate: object = {
  response: null,
  isError: false,
  errorMessage: '',
  loader: false,
  previewScreeningData: null,
  from: '',
};

export const getScreeningReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_SCREENING_SUCCESS: {
      return {
        ...state,
        isError: false,
        response: action.payload?.data,
        loader: false,
      };
    }

    case GET_SCREENING_FAILURE:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loader: false,
      };

    case GET_SCREENING_LOADER:
      return {
        ...state,
        loader: true,
      };

    case PREVIEW_SCREENING:
      return {
        ...state,
        previewScreeningData: action.payload,
      };

    default:
      return state;
  }
};
